import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading'
import ConfigurationHeader from '../../components/heading/ConfigurationHeader'
import Input from "../../components/Input/Input"
import "./AppBuildConfiguration.css"
import { Autocomplete, Box, CircularProgress, Tab, Tabs, TextField } from '@mui/material'
import { codemagicGetRequest, codemagicPostRequest } from '../../services/networkService'
import { openPopup } from '../../stateManagement/actions/popupActions'
import { AppBuildListResponse, AppBuildResponse, appDownloadType } from './AppBuildTypes'
import { EnvironmentRegistry } from '../../services/registry/environmentRegistry'
import { configurationAttributeType, newConfigurationNames } from '../../types'
import { convertValuesToConfig, doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, postConfiguration, updateConfiguration } from '../../services/uiConfigService'
import * as Sentry from "@sentry/react";
import { appValueTypes } from '../../types/types'
import { defaultAppInputValues } from '../defaultConfigurations/appConfigDefaultValues'
import { deepClone } from '@mui/x-data-grid/utils/utils'
import { Button, Popup } from 'semantic-ui-react'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { IndentWrapper } from '../orderConfiguration/OrderConfiguration'
import QuestionHeading from '../../components/heading/QuestionHeading'
import { ConfirmationPopUp } from '../../components/popup/confirmationPopUp'
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions'
import DefaultHeading from '../../components/heading/DefaultHeading'


const AppBuildConfiguration = () => {

	const [selectedTab, setSelectedTab] = useState('configure');
	const [isBuildDisabled, setIsBuildDisabled] = useState(true);
	const handleChange = (event: React.SyntheticEvent, newValue: string)=>{
		setSelectedTab(newValue);
	}
	return (
		<div className="app_build_config_container">
			{/* <TabContext value={selectedTab}>
			<Box className="app_build_tab_conatiner" sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<TabList onChange={handleChange} variant='fullWidth'>
					<Tab label="Configure" value="configure" />
					<Tab label="Build And Download" value="build" disabled={isBuildDisabled}/>
				</TabList>
			</Box>
			<TabPanel className='app_build_panel' value="configure"><ConfigureAppBuild setIsBuildDisabled={setIsBuildDisabled} /></TabPanel>
			<TabPanel className='app_build_panel' value="build"><AppBuildDownload/></TabPanel>
			</TabContext> */}
			<ConfigureAppBuild setIsBuildDisabled={setIsBuildDisabled} />
		</div>
	);
}

const ConfigureAppBuild = (props:{setIsBuildDisabled: React.Dispatch<React.SetStateAction<boolean>>})=>{
	const appConfig = useRef<configurationAttributeType<any>[]>([]);
	const [values, setValues] = useState<appValueTypes>(deepClone(defaultAppInputValues))
	const [openConfirmModal, setOpenConfirmModal] = useState(false);


	const updateAppConfiguration = async()=>{
		try {
			const configName:newConfigurationNames = 'app_configuration';
			const convertedVals = convertValuesToConfig(values, appConfig.current);
			await doFinalConfigSubmit(configName,convertedVals);
			if(!values.appPackageName.value && !values.iosAppPackageName.value){
				props.setIsBuildDisabled(true)
			}else{
				props.setIsBuildDisabled(false)
			}
		} catch (err) {
			openPopup("Alert", "Configurations not updated")
			// Sentry.captureException(err);
			console.log("err===", err)
		}
	}

	const getAppConfig = async ()=>{
		const resp = await getNewConfiguration('app_configuration');
		appConfig.current = resp?.domainValues ?? [];
		Object.keys(values).forEach(key=>{
			const configObject = appConfig.current.find(config=>config.name === key);
			values[key].value = configObject ? configObject.value : values[key].value;
		})
		if((values?.appPackageName?.value || values?.iosAppPackageName?.value) && values?.appIcon?.value && values?.appName?.value){
			props.setIsBuildDisabled(false)
		}
		setValues({...values})
	}

	useEffect(()=>{
		getAppConfig();
	},[])


    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

	return (
		<div className="config_form_container">

			<DefaultHeading heading='App Build Configuration' />
				<IndentWrapper indent={0}>
                    <QuestionHeading>
                    Android App Package Name
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.appPackageName.value} onChange={handleValueChange} name="appPackageName" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    IOS App Package Name
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.iosAppPackageName.value} onChange={handleValueChange} name="iosAppPackageName" />
                    </div>
                </IndentWrapper>

				<IndentWrapper indent={0}>
                    <QuestionHeading>
                    Playstore Link
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.psLink.value} onChange={handleValueChange} name="psLink" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    App Store Link
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.appStoreLink.value} onChange={handleValueChange} name="appStoreLink" />
                    </div>
                </IndentWrapper>
				<div className='submit_app_build_config_container'>
					<Button variant="contained" className="submit_app_build_config" onClick={()=>{setOpenConfirmModal(true)}}>Save</Button>
				</div>
				<ConfirmationPopUp 
					message='Are you sure you want to save?'
					openConfirmModal={openConfirmModal}
					setOpenConfirmModal={setOpenConfirmModal}
					successMethod={() => updateAppConfiguration() }
				/>
		</div>
	);
}

const AppBuildDownload = ()=>{
	const [branches, setBranches] = useState<string[]>([])
	const [isBuilding, setIsBuilding] = useState(false);
	const appId = useRef<string>("");
	const [values, setValues] = useState<appValueTypes>(deepClone(defaultAppInputValues))
	const [selectedBranch, setSelectedBranch] = useState<string>("master");
	const [selectedAppType, setSelectedAppType] = useState<string>("");
	const [availableAppType, setAvailableAppType] = useState<string[]>([]);
	const [versionName, setVersionName] = useState<string>("");
	const [androidAppDownload, setAndroidAppDownload] = useState<appDownloadType>()
	const [iosAppDownload, setIosAppDownload] = useState<appDownloadType>()
	const [versionCode, setVersionCode] = useState<string>("");
	const [buildStatus, setBuildStatus] = useState<string>("");
	const appConfig = useRef<configurationAttributeType<any>[]>([]);

	const getBuildList = async () =>{
		try{
			const prevBuildresponse:{data:AppBuildListResponse} = await codemagicGetRequest("/builds");
			const application = prevBuildresponse.data.applications.find(applicationObject=>applicationObject.appName === 'channelkart-flutter');
			if(application){
				setBranches(application.branches);
				appId.current = application._id;
			}

		}catch(error){
			console.error(error)
			openPopup("Error","Error occured while fetching previous builds");
		}
	}

	const getAppConfig = async ()=>{
		const resp = await getNewConfiguration('app_configuration');
		appConfig.current = resp?.domainValues ?? [];
		Object.keys(values).forEach(key=>{
			const configObject = appConfig.current.find(config=>config.name === key);
			values[key].value = configObject ? configObject.value : values[key].value;
		})
		setValues({...values})
		const prevAppTypeKey = values.appBuildType.value === "Android"  ? "androidAppId" : "iosAppId"
		if(values[prevAppTypeKey].value !== values.appBuildId.value || (!values[prevAppTypeKey].value && values.appBuildId.value)){
			setBuildDetails(values.appBuildId.value);
		}
		const availabletypes:string[] = [];
		if(values.appPackageName.value){
			availabletypes.push("Android")
		}
		if(values.iosAppPackageName.value){
			availabletypes.push("Ios")
		}
		setAvailableAppType(availabletypes);
		setSelectedAppType((availabletypes.length ? availabletypes[0] : ""))
	}

	const setBuildDetails = async (buildId:string) => {
		const response = await codemagicGetRequest('/builds/'+buildId);
		const buildDetails:AppBuildResponse = response.data;
		const buildAPKObject = buildDetails.build.buildActions.find(buildAction=>buildAction.name == "Build APK with Flutter")
		if(buildDetails.build.status === "canceled"){
			openPopup("Alert","Your previous build was Canceled")
			setVersionCode("");
			setVersionName("");
			setSelectedBranch("master");
			setIsBuilding(false);
		}
		else if((!buildAPKObject?.status) || (buildAPKObject?.status !== "success" && buildAPKObject?.status !== "failed" && buildAPKObject?.status !== "canceled")){
			setVersionCode(buildDetails.build.dynamicConfig.environment.variables.VERSION_CODE)
			setVersionName(buildDetails.build.dynamicConfig.environment.variables.VERSION_NAME)
			setSelectedBranch(buildDetails.build.branch);
			setBuildStatus(buildDetails.build.status)
			setIsBuilding(true)
		}else if(buildAPKObject?.status === "success" ){
			const prevAppTypeKey = values.appBuildType.value === "Android"  ? "androidAppId" : "iosAppId"
			values[prevAppTypeKey].value = buildId;
			setValues({...values})
			setIsBuilding(false);
			updateAppConfiguration();
			setVersionCode("")
			setVersionName("")
			setSelectedBranch("master");
		}else if(buildAPKObject?.status === "failed"){
			openPopup("Alert","Your previous build was failed")
			setVersionCode("");
			setVersionName("");
			setSelectedBranch("master");
			setIsBuilding(false);
		}
	}

	useEffect(()=>{
		const interval = setInterval(() => {
			if(values.appBuildId.value && isBuilding){
				setBuildDetails(values.appBuildId.value)
			}
		}, 5000);
	
		return () => {
		clearInterval(interval); 
		};
	},[isBuilding])

	useEffect(() => {
		getBuildList();
		getAppConfig();
	}, [])

	const getUnixTimeStamp = ()=>{
		const currentDate = new Date();

		// Calculate the date 1 day from now
		const oneDayFromNow = new Date(currentDate);
		oneDayFromNow.setDate(currentDate.getDate() + 1);

		// Get the UNIX timestamp of 1 day from now in seconds
		const timestampOneDayFromNow = Math.floor(oneDayFromNow.getTime() / 1000);
		return timestampOneDayFromNow;
	}

	useEffect(()=>{
		const updateAppDownloadLink = async()=>{
			if(values.androidAppId.value){
				const response = await codemagicGetRequest('/builds/'+values.androidAppId.value);
				const buildDetails:AppBuildResponse = response.data;
				const privateLink = (buildDetails.build.artefacts.length ? buildDetails.build.artefacts[0].url : "").replace('https://api.codemagic.io',"");
				if(privateLink){
					const publicDownloadLink = await codemagicPostRequest(privateLink+'/public-url',{expiresAt:getUnixTimeStamp()});
					setAndroidAppDownload({
						link:publicDownloadLink.data.url,
						name:buildDetails.build.dynamicConfig.environment.variables.VERSION_NAME,
						code:buildDetails.build.dynamicConfig.environment.variables.VERSION_CODE
					})
				}
			}
			if(values.iosAppId.value){
				const response = await codemagicGetRequest('/builds/'+values.iosAppId.value);
				const buildDetails:AppBuildResponse = response.data;
				const privateLink = (buildDetails.build.artefacts.length ? buildDetails.build.artefacts[0].url : "").replace('https://api.codemagic.io',"");
				if(privateLink){
					const publicDownloadLink = await codemagicPostRequest(privateLink+'/public-url',{expiresAt:getUnixTimeStamp()});
					setIosAppDownload({
						link:publicDownloadLink.data.url,
						name:buildDetails.build.dynamicConfig.environment.variables.VERSION_NAME,
						code:buildDetails.build.dynamicConfig.environment.variables.VERSION_CODE
					})
				}
			}
		}
		updateAppDownloadLink();
	},[values])

	const initiateBuild = async (appId:string,branch:string, versionCode:string, versionName:string, selectedAppType:string)=>{
		const reqBody = {
			"appId": appId,
			"workflowId": selectedAppType === "Android" ? "android-app" : "ios-app",
			"branch": branch,
			"environment": {
			  "variables": {
				"VERSION_NAME":versionName,
				"VERSION_CODE":versionCode,
				"LOB":EnvironmentRegistry.getCurrentLob(),
				"SERVER_URL":EnvironmentRegistry.getServerUrl(),
				"BUILD_APP_BUNDLE":"false",
				"ANDROID_KEYSTORE_FILE":"server.keystore",
				"IOS_PROVISIONING_PROFILE":"CodeMagicIOS"
			  }
			}
		}
		return codemagicPostRequest('/builds',reqBody);
	}

	const buildApp = async ()=>{
		if( selectedBranch && versionCode && versionName && selectedAppType){
			setBuildStatus("Initiating")
			setIsBuilding(true);
			const buildReponse = await initiateBuild(appId.current,selectedBranch,versionCode,versionName, selectedAppType);
			values.appBuildId.value = buildReponse.data.buildId;
			values.appBuildType.value = selectedAppType;
			setValues({...values});
			updateAppConfiguration();
			openPopup("Success","Build Initiated")
		}
	}

	const updateAppConfiguration = async()=>{
		try {
			const configName:newConfigurationNames = 'app_configuration';
			let clientConfig = await getMetaDataConfig("clientconfig");
			const convertedVals = convertValuesToConfig(values, appConfig.current);
			if (clientConfig.find((config: { domainType: string }) => config.domainType === configName)) {
			  await updateConfiguration(configName, convertedVals)
			} else{
				await postConfiguration(configName, convertedVals)
			}
		} catch (err) {
			// Sentry.captureException(err);
			console.log("err===", err)
		}
	}

	const stopBuild = async ()=>{
		await codemagicPostRequest('/builds/'+values.appBuildId.value+'/cancel')
		values.appBuildId.value = values.androidAppId.value
		setValues({...values});
		updateAppConfiguration();
		setIsBuilding(false);
	}

	return (
		<div className="config_form_container">
			<div className="form_header">
				<BorderHeading> Build App </BorderHeading>
			</div>
			<div className="app-build-container">
			<TextField className="app-build-input" disabled={isBuilding} value={versionName} onChange={(element)=>{setVersionName(element.target.value)}} label="Version Name*" variant="outlined" />
			<TextField className="app-build-input" disabled={isBuilding} value={versionCode} onChange={(element)=>{setVersionCode(element.target.value)}} label="Version Code*" variant="outlined" />
			<Autocomplete
				disabled={isBuilding}
				disableClearable
				disablePortal
				value={selectedBranch}
				className="app-build-input"
				id="elementType"
				options={branches}
				onChange={(event, value)=>{setSelectedBranch(value)}}
				renderInput={(params) => <TextField {...params}  label="Select Branch" />}
			/>
			<Autocomplete
				disabled={isBuilding}
				disableClearable
				disablePortal
				value={selectedAppType}
				className="app-build-input"
				id="elementType"
				options={availableAppType}
				onChange={(event, value)=>{setSelectedAppType(value)}}
				renderInput={(params) => <TextField {...params}  label="Select App Type" />}
			/>
				<div className='build-actions app-build-input'>
					{!isBuilding && <Button className='build-action-button' onClick={() => {
						validateWithOtp(buildApp,["uat","demo","prod","prod-egtm"],"admin")
					}}> Build App</Button>}
					{isBuilding && 
						<Button className='build-action-button'> 
							<CircularProgress size={15} color='inherit'/> 
							{buildStatus}
						</Button>
					}
					{isBuilding && <Button className='build-action-button' onClick={() => validateWithOtp(stopBuild,["uat","demo","prod","prod-egtm"],"admin")}> Stop Build</Button>}
				</div>
			</div>


			{(androidAppDownload || iosAppDownload) && 
			<>
				<div className="form_header">
					<BorderHeading> Previous Build </BorderHeading>
				</div>
				<div className="app-download-container">
					{androidAppDownload && <div className='android-app-container'>
						<a href={androidAppDownload.link}> Download Android App </a>
						<div>Version Name: ({androidAppDownload.name})</div>
						<div>Version Code: ({androidAppDownload.code})</div>
						
					</div>}
					{iosAppDownload && <div className='android-app-container'>
						<a href={iosAppDownload.link}> Download IOS App </a>
						<div>Version Name: ({iosAppDownload.name})</div>
						<div>Version Code: ({iosAppDownload.code})</div>
					</div>}
				</div>
			</>
			}
		</div>
	);
}

export default AppBuildConfiguration
